import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API_URL } from "../utils/constants";
import { getBrowserName, getOSName } from "../utils/analytics";

export default function useVisit() {
  const location = useLocation();

  useEffect(() => {
    const payload = {
      device_type: navigator.userAgent,
      os: getOSName(),
      browser: getBrowserName(),
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      referrer: document.referrer,
      url: window.location.href,
    }

    fetch(API_URL+'/visite/store', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(payload)
    })
  }, [location]);
}